// src/utils/logHistory.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function logHistory({
  clientId,
  docId,
  user,
  action,
  details = {},
  note = "",
  type = "inventory",
}) {
  if (!clientId || !docId || !user?.uid || !action) return;

  const payload = {
    timestamp: serverTimestamp(),
    action,
    userId: user.uid,
    role: user.role,
    docId,
    details,
    note,
    type,
  };

  try {
    await addDoc(collection(db, "Clients", clientId, "globalHistory"), payload);
    if (type === "inventory") {
      await addDoc(
        collection(db, "Clients", clientId, "inventories", docId, "history"),
        payload
      );
    }
  } catch (err) {
    console.error("❌ Failed to log history:", err.message);
  }
}
